module.exports = __webpack_public_path__ + "9f6a249aa473b57b69b21f4306ed9e51.png";